import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcphealth0getGetHealthResponseSchema = jsonObject
export type tcphealth0getGetHealthResponse = z.infer<typeof tcphealth0getGetHealthResponseSchema>
